import { type Channel, ContentType } from "@ca.vmedia.tv/domains";
import { CardDataType, type CardData, ComponentName } from "../types";

export class ChannelLiveCardData implements CardData {

    private readonly channel: Channel;

    constructor(item: Channel) {
        this.channel = item;
    }

    getChannel(): Channel {
        return this.channel;
    }

    getId(): string {
        return `${this.channel.id}`;
    }

    getClass(): string {
        return 'channel-program-card';
    }

    getType(): CardDataType {
        return CardDataType.Guide;
    }

    getContentType(): ContentType {
        return ContentType.LiveTV;
    }

    getComponentName(): ComponentName {
        return ComponentName.CHANNEL_LIVE;
    }
}
